
import { defineComponent } from '@nuxtjs/composition-api';
import ConfirmDialog from '@/components/common/ConfirmDialog.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import PublicPortfolioConnectionActionsMixin from '@/components/partials/public-portfolio/PublicPortfolioConnectionActions/PublicPortfolioConnectionActionsMixin';
import { publicPortfolioPopUps } from '@/components/partials/public-portfolio/constants';

export default defineComponent({
  name: 'PublicPortfolioConfirmSendRequest',
  components: { ConfirmDialog, BravadoButtonV3 },
  mixins: [PublicPortfolioConnectionActionsMixin],
  data() {
    return {
      modalName: publicPortfolioPopUps.CONFIRM_SEND_REQUEST,
    };
  },
  methods: {
    async confirmSendRequest() {
      this.hide();

      this.$analytics.logEvent('public-portfolio__request__button__click');

      await this.sendConnectionRequest();
    },
    hide() {
      this.$modal.hide(publicPortfolioPopUps.CONFIRM_SEND_REQUEST);
    },
  },
});
